<template>
  <div>
    <div class="home d-flex justify-content-center">
      <video playsinline autoplay muted loop poster="../assets/video/header_bloky_thumb.jpg" id="bgvid">
        <source src="../assets/video/header_nove_bloky.mp4" type="video/mp4">
      </video>
      <div class="intro-text d-flex align-items-end px-md-5 text-center">
        <div>
          <h1 class="mb-5">Bory Nové Bloky</h1>
          <!-- <p v-html="$t('Nová etapa v&nbsp;dynamickej časti štvrti Bory, ktorá ponúka výbornú <br>občiansku vybavenosť v&nbsp;pešej dostupnosti. Obchody, služby, kino či fitness centrum len pár minút od polouzavretého vnútrobloku.')"></p> -->
          <b-button @click="scrollTo('mapbox')" target="_blank" class="d-block d-md-inline-block mt-2 mt-md-0 btn btn-white">{{ $t('Pozrite si ponuku bytov') }}</b-button>
          <!-- <b-button @click="scrollTo('virtual-section')" target="_blank" class="d-block d-md-inline-block ml-md-3 mt-2 mt-md-0 btn btn-white">{{ $t('Poprechádzajte sa vo VR') }}</b-button> -->
          <div class="scroll-down" @click="scrollTo('district')">
            <span class="scroll-down-label">{{ $t('Zistite viac') }}</span>
            <div class="scroll-down-arrows">
              <svg viewBox="0 0 60 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <polyline points="2,2 30,28 58,2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg viewBox="0 0 60 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <polyline points="2,2 30,28 58,2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="district p-md-3 pt-3 pt-md-5" id="district">
      <div class="d-flex flex-wrap align-items-start top mb-5">
        <div class="col-md-6 px-md-5">
          <h2 class="mb-4 m-md-0">{{ $t('Vyberte si váš nový domov') }}</h2>
        </div>
        <div class="col-md-6 d-flex justify-content-center">
          <p class="m-0">{{ $t('Bory kombinujú aktívne rodinné bývanie s bohatým verejným priestorom, kompletnou vybavenosťou, množstvom obchodov a pohodlnou dopravou do centra.') }}</p>
        </div>
      </div>
      <div id="mapbox" class="position-relative">
        <BuildingMap
          stage="boryNoveBloky"
          map-key="boryNoveBloky"
          background-image="/map/b_nove_bloky.jpg"
          marker-color="#778cae"
          :marker-scale="1.2"
        />
        <!-- <div id="vr-badge">
          <a href="https://mollyinvr.com/projects/penta/nadvorie/" target="_blank">
            <div class="d-flex flex-column align-items-center justify-content-center p-4 text-center box">
              <img src="../assets/icons/360.svg">
              <p>{{ $t('Prejdite sa Virtuálnou realitou') }}</p>
            </div>
          </a>
        </div> -->
      </div>
    </section>

    <section id="tabulka">
      <FlatsTable :stages="['boryNoveBloky']" :showStageAndDate="false" :showMonthly="false" :show-vr="false"></FlatsTable>
    </section>

    <section class="finance p-md-5 pt-3 pt-md-5">
      <div class="row flex align-items-center">
        <div class="col-12 col-md-4 text-center">
          <h2>Financovanie</h2>
          <div class="highlight">10/90</div>
          <b-button href="../novinky/ako-financovat-vase-byvanie-v-etape-bory-nadvorie" class="d-block d-md-inline-block mb-4" squared variant="primary">{{ $t('Zistiť viac') }}</b-button>
        </div>
        <div class="col-md-8 pb-3 pb-md-0 pr-md-0">
          <div class="right-img bg-img-2"></div>
        </div>
      </div>
    </section>

    <!-- <section class="virtual p-md-5 pt-3 pt-md-5" id="virtual-section">
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="row">
            <div class="col-12 col-md-6 d-flex align-items-center justify-content-center embed-responsive embed-responsive-1by1 bg-primary bg-flats">
              <b-button @click="$bvModal.show('vzoroveBytModal')" class="d-block d-md-inline-block mb-4" squared variant="primary">{{ $t('Vzorové byty') }}</b-button>
            </div>
            <div class="col-12 col-md-6 d-flex align-items-center justify-content-center embed-responsive embed-responsive-1by1 bg-secondary bg-exterier">
              <b-button href="#" class="d-block d-md-inline-block mb-4" squared variant="primary">{{ $t('Exteriér') }}</b-button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 p-5">
          <h2>Prejdite sa virtuálnou prehliadkou</h2>
        </div>
      </div>
    </section> -->

    <ScheduleTimeline :phases="schedulePhases" />
    

    <section class="about-bottom p-md-3 pl-md-5">
      <div class="d-flex flex-wrap">
        <div class="col-md-4 py-4">
          <h2 class="mb-4">{{ $t('Návrh interiéru v cene bytu a zvýhodnená cena na nábytok') }}</h2>
          <p class="mb-3" v-html="$t('Nelámte si hlavu s možnosťami ako váš nový domov zariadiť. V spolupráci so spoločnosťou NARIO vám prinášame možnosť využiť bezplatné vyhotovenie návrhu interiéru a taktiež zvýhodnenú cenu na nábytok.')"></p>
          <b-button href="../nabytok" class="d-block d-md-inline-block mb-4" squared variant="primary">{{ $t('Zistiť viac') }}</b-button>
        </div>
        <div class="col-md-8 pb-3 pb-md-0 pr-md-0">
          <div class="right-img bg-img-2"></div>
        </div>
      </div>
    </section>

    <section class="section-3 p-3">
      <div>
        <div class="row px-2">
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-1">
              <h3>{{ $t('Bývanie v mestskom štýle') }}</h3>
              <p>{{ $t('Bývanie v etape Bory Nové Bloky ponúka vybavenosť, akoby ste žili priamo v centre mesta. Nemocnica, nákupné centrum, potraviny, MHD zastávky, škôlka aj hrádza len na skok od domu.') }}</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-3">
              <h3>{{ $t('Komunitné priestory') }}</h3>
              <p v-html="$t('Vo vnútrobloku nájdete detské ihriská, priestor na šport, oddychové zóny, či dokonca aj grilovisko.')"></p>
              <p v-html="$t('Ak dávate prednosť aktivitám v interiéri, poteší vás spoločenská miestnosť, ktorú môžete využiť napríklad na rodinné oslavy, či len na spoločne strávené poobedie so susedmi.')"></p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="col-12 p-md-5 bg-col bg-col-2">
              <h3>{{ $t('Bezpečná zóna bez áut') }}</h3>
              <p v-html="$t('Takmer všetky parkovacie miesta projektu budú umiestnené v podzemnej garáži, čím vytvoria príjemný vnútroblok, odľahčený od premávky.')"></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about-bottom-2">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 signature-section">
          <h2 class="mb-4" v-html="$t('MHD')"></h2>
          <p class="mb-3" v-html="$t('Z Borov sa pohodlne dostanete do centra aj do okolitých časti mesta - či už do práce, na stretnutie alebo na návštevu za priateľmi, MHD máte poruke.')"></p>
          <p class="mb-3" v-html="$t('V blízkosti etapy Bory Nové Bloky sa nachádzajú zástavky Nemocnica Bory a OC Bory, odkiaľ premávajú viaceré autobusové linky (21, 25, 30, 32, 36, 92 a 216).')"></p>
          <p class="mb-3" v-html="$t('Viac detailov ohľadom autobusových zastávok a spojoch v štvrti nájdete v interaktívnej mape.')"></p>
        </div>
        <div class="col-md-6 bg map-container">
          <BusStopsMap />
        </div>
      </div>
    </section>

    <ContactForm selectedStage="boryNoveBloky" id="contact-form"></ContactForm>

    <b-modal id="vzoroveBytModal" size="xl" centered hide-footer hide-header>
      <div class="vzorove-modal">
        <p class="vzorove-modal-title">{{ $t('Vyberte si z modelových bytov a vstúpte do virtuálnej prehliadky interiéru') }}</p>
        <div class="vzorove-tiles">
          <div class="vzorove-tile" v-for="(apt, i) in vzoroveBytTypes" :key="i" :style="{ backgroundImage: 'url(' + apt.image + ')', backgroundSize: 'cover', backgroundPosition: 'center' }">
            <div class="vzorove-tile-overlay"></div>
            <span class="vzorove-tile-label">{{ $t(apt.label) }}</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import FlatsTable from "@/components/flats/FlatsTable";
import BuildingMap from "@/components/maps/BuildingMap";
import ContactForm from "@/components/shared/ContactForm";
import BusStopsMap from "@/components/maps/BusStopsMap";
import ScheduleTimeline from "@/components/home/ScheduleTimeline";


export default {
  name: "BoryNoveBloky",
  components: {BuildingMap, FlatsTable, ContactForm, BusStopsMap, ScheduleTimeline},
  data() {
    return {
      vzoroveBytTypes: [
        { label: '1,5-izbový byt', image: require('@/assets/images/nove-bloky/1_5_izbove.jpg') },
        { label: '2-izbový byt',  image: require('@/assets/images/nove-bloky/2_izbove.jpg') },
        { label: '3-izbový byt',  image: require('@/assets/images/nove-bloky/3_izbove.jpg') },
        { label: '4-izbový byt', image: require('@/assets/images/nove-bloky/4_izbove.jpg') },
        { label: '5-izbový byt',   image: require('@/assets/images/nove-bloky/5_izbove.jpg') },
      ],
      schedulePhases: [
        { icon: 'zahajenie-vystavby', title: 'Začiatok<br> výstavby', date: '4. kvartál 2026', status: 'fill-min' },
        { icon: 'hruba-stavba', title: 'Žiadosť<br> o kolaudáciu', date: '3. kvartál 2029' },
        { icon: 'kolaudacia', title: 'Kolaudačný<br> proces', date: '4. kvartál 2029' },
        { icon: 'odovzdanie-bytov', title: 'Odovzdávanie<br> bytov', date: '1. - 2. kvartál 2030' },
        { icon: 'kluce-byvanie', title: 'Vaše<br> bývanie' }
      ]
    }
  },
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      const offset = 80; // Adjust this value to set the offset in pixels
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },
  }
}
</script>

<style lang="sass" scoped>
$md: 768px

#mapbox
  padding: 0

#mapbox2
  padding: 0
  z-index: 9999

video
  object-fit: cover
  width: 100vw
  height: 100vh
  position: absolute
  top: 0
  left: 0

#vr-badge
  position: absolute
  width: 140px
  height: 140px
  background: #fff
  border-radius: 50%
  top: 35%
  right: 10%
  z-index: 99
  cursor: pointer

  @media (max-width: $md)
    width: 110px
    height: 110px
    bottom: 20px
    right: 20px

  img
    max-width: 70%
    margin-bottom: 2px

  p
    color: #000
    font-size: 16px

    @media (max-width: $md)
      font-size: 14px

#bory-vr
  width: 100%
  height: 80vh
  background: #ccc
  position: relative
  box-sizing: border-box

#woowstudio
  position: absolute
  width: 100%
  height: 100%
  padding: 0
  margin: 0
  box-sizing: border-box

.about-bottom-2
  .bg
    background: url('../assets/images/bory5/06H_BH3B_static_ext_round_02.jpg') top/cover no-repeat
  .map-container
    background: none
    min-height: 400px
    padding: 0
    display: flex
    iframe
      flex: 1

  .signature-section
    h2
      max-width: 570px
      font-size: 40px
      line-height: 45px
      letter-spacing: -1px
      font-weight: 400
      @media (max-width: $md)
        font-size: 28px
        line-height: 40px
        letter-spacing: -1px
    p
      max-width: 570px

    .btn
      align-self: flex-start
.about-bottom
  padding-bottom: 11px!important
  .right-img
    background: url(../assets/images/bory3/bory3-domov.jpg) center/cover no-repeat
  .bg-img-2
    background: url("../assets/images/nove-bloky/NABYTOK.jpg") center/cover no-repeat
    @media (max-width: $md)
      height: 40vh
      background-size: cover

.finance
  background: var(--darkBlue)
  .right-img
    min-height: 400px
    background: url(../assets/images/nove-bloky/FINANCOVANIE.jpg) center/cover no-repeat

  .highlight
    color: var(--primary)
    font-size: 66px
    font-weight: bold
    margin-bottom: 20px

.virtual
  background: var(--grey)

  .bg-flats
    background: url(../assets/images/nove-bloky-bg-flats.jpg) center/cover no-repeat

  .bg-exterier
    background: url(../assets/images/nove-bloky-bg-ext.jpg) center/cover no-repeat

.section-3
  background: var(--grey)
  color: #fff
  text-align: left
  .bg-img
    background: url("../assets/images/nadvorie_konfig.jpg") top/cover no-repeat
    background-position: center
  
  h2
    font-size: 55px
    line-height: 60px
    font-weight: 300
    margin-bottom: 20px
    @media (max-width: $md)
      font-size: 28px
      line-height: 40px
      letter-spacing: -1px
      margin-bottom: 15px
  p
    max-width: 480px
    font-weight: 500
    &:last-child
      margin-bottom: 220px
      @media (max-width: $md)
        margin-bottom: 0
  .bg-col
    height: 800px
    @media (max-width: $md)
      height: 60vh
      margin-bottom: 16px
      padding: 30px
    h3
      font-size: 28px
      line-height: 32px
      font-weight: 400
      margin-bottom: 20px
    p
      font-size: 16px
      line-height: 21px
      font-weight: 500
      max-width: 320px
      @media (max-width: $md)
        font-size: 12px
        line-height: 16px
        max-width: 100%
  .bg-col-1
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/nove-bloky/mestsky_styl.jpg") center/cover no-repeat
    background-position: center

    @media (max-width: $md)
      background-position: center
  .bg-col-2
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/nove-bloky/bez_aut.jpg") bottom/cover no-repeat
    background-position: center
  .bg-col-3
    background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/nove-bloky/komunitne_priestory.jpg") center/cover no-repeat
    background-position: center
    @media (max-width: $md)
      background-position: center
  .col-md-4
    padding-left: 8px
    padding-right: 8px
.home
  background: linear-gradient(179.37deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%), url("../assets/images/bory5/01E_BH3B_static_ext_round_02.jpg") bottom/cover no-repeat
  position: relative

  &:after
    content: ""
    width: 100%
    height: 100%
    position: absolute
    left: 0
    top: 0
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.53) 0.71%, rgba(0, 0, 0, 0) 99.63%)
  .intro-text
    position: relative
    z-index: 9
    margin-bottom: 60px

  .scroll-down
    display: flex
    flex-direction: column
    align-items: center
    cursor: pointer
    margin-top: 40px
    user-select: none

    .scroll-down-label
      color: #fff
      font-size: 14px
      font-weight: 500
      letter-spacing: 1px
      text-transform: uppercase
      margin-bottom: 10px
      opacity: 0.85

    .scroll-down-arrows
      display: flex
      flex-direction: column
      align-items: center
      gap: 0

      svg
        width: 44px
        height: 26px
        opacity: 0
        animation: arrowFade 1.6s ease-in-out infinite

        &:nth-child(1)
          animation-delay: 0s

        &:nth-child(2)
          animation-delay: 0.3s

  p
    margin-bottom: 30px
    max-width: 770px

  .btn-white
    background: #fff
    color: #001F33
    border-radius: 0
    border-color: #fff
    position: relative
    // padding-left: 55px

    // &:before
    //   content: ""
    //   width: 27px
    //   height: 16px
    //   background: url("../assets/icons/360.svg") center/contain no-repeat
    //   position: absolute
    //   left: 15px
    //   top: 50%
    //   transform: translateY(-50%)

    &:hover
      background: #CFEDFF
      border-color: #CFEDFF

.district
  background: var(--darkBlue)
  img
    width: 100%
.top
  h2
    font-weight: 300
    font-size: 55px
    line-height: 60px
    letter-spacing: -3px
    @media (max-width: $md)
      font-size: 40px
      line-height: 40px
      letter-spacing: -2px
  p
    font-weight: 500
    max-width: 415px

.vzorove-modal
  padding: 10px 0

  .vzorove-modal-title
    text-align: center
    font-size: 18px
    font-weight: 500
    color: #001F33
    margin-bottom: 24px
    max-width: 100%

  .vzorove-tiles
    display: flex
    gap: 8px

    @media (max-width: 768px)
      flex-direction: column

    .vzorove-tile
      flex: 1
      aspect-ratio: 1 / 1
      position: relative
      cursor: pointer
      overflow: hidden
      display: flex
      align-items: center
      justify-content: center

      &:hover
        .vzorove-tile-overlay
          background: rgba(0, 0, 0, 0.25)

      .vzorove-tile-overlay
        position: absolute
        inset: 0
        background: rgba(0, 0, 0, 0.35)
        transition: background 0.3s ease

      .vzorove-tile-label
        position: relative
        z-index: 1
        color: #fff
        font-size: 15px
        font-weight: 600
        text-align: center
        padding: 0 10px
        line-height: 1.2
</style>

<style>
@keyframes arrowFade {
  0% { opacity: 0; transform: translateY(-6px); }
  40% { opacity: 1; transform: translateY(0); }
  80% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 0; transform: translateY(6px); }
}
</style>
